// Base configuration service following client pattern
export default class ConfigService {
  protected baseUrl: string;

  constructor() {
    // Use environment variable or fallback to localhost for development
    this.baseUrl =
      process.env.REACT_APP_MP_BASE_URI || "https://localhost:44300";
  }

  // Build full URL for API endpoints
  makeUrl(subUrl: string): string {
    return `${this.baseUrl}${subUrl}`;
  }

  // GET request
  get<T>(url: string): Promise<T> {
    return fetch(url).then((response) => {
      if (!response.ok) {
        const error = new Error(
          `Failed to fetch: ${response.statusText}`,
        ) as any;
        error.status = response.status;
        throw error;
      }
      return response.json();
    });
  }

  // POST request — uses text/plain to avoid CORS preflight, which fails for
  // sendBeacon during page unload (application/json triggers an OPTIONS request
  // that doesn't complete before the page is torn down).
  post<T, K>(url: string, body: K): Promise<T> {
    return fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "text/plain",
      },
      body: JSON.stringify(body),
    }).then((response) => {
      if (!response.ok) {
        throw new Error(`Failed to post: ${response.statusText}`);
      }
      return response.json();
    });
  }

  postJson<T, K>(url: string, body: K): Promise<T> {
    return fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    }).then((response) => {
      if (!response.ok) {
        throw new Error(`Failed to post: ${response.statusText}`);
      }
      return response.json();
    });
  }
}
